import { getStorageData } from "@/utils/storage";
import {
  getCompanyUsers as apiGetCompanyUser,
  getUserById as apiGetUserById,
  deleteUser as apiDeleteUser,
  addUser as apiCreateCompanyUser,
  updateUser as apiUpdateUser,
  getUsersAcl as apiGetUsersAcl,
  getUserProgram as apiGetUserProgram,
  getUserSchedule as apiGetUserSchedule,
  getUserRecords as apiGetUserRecords,
  getUserCertificate as apiGetUserCertificate,
  getUserRecordsDownload as apiGetUserRecordsDownload,
  getUserCertificateDownload as apiGetUserCertificateDownload,
} from "../api/company/users";
import { getOperational as apiGetOperational } from "../api/company";

const companyUser = {
  namespaced: true,
  state: {
    users: [],
    user: {
      company: {},
      acl: {
        roles: []
      }
    },
    program: {},
    schedule: [],
    records: {},
    recordScore: {},
    operational: {},
    isLoading: false
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    user(state) {
      return state.user;
    },
    users(state) {
      return state.users;
    },
    operational(state) {
      return state.operational;
    },
    acl(state) {
      return state.user.acl;
    },
    settings(state) {
      return state.user.settings;
    },
    program(state) {
      return state.program;
    },
    schedule(state) {
      return state.schedule;
    },
    records(state) {
      return state.records;
    }
  },
  mutations: {
    setCompanyUsers(state, payload) {
      state.users = payload;
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setLoading(state, payload) {
      state.isLoading = payload;
    },
    setOperational(state, payload) {
      state.operational = { ...state.operational, ...payload };
    },
    setState(state, { key, value }) {
      state[key] = value;
    }
  },
  actions: {
    async createCompanyUser(_, user) {
      const company = getStorageData("company");

      const { id: companyId } = company;

      const data = await apiCreateCompanyUser(companyId, user);

      return data;
    },
    async updateCompanyUser(_, updatedUser) {
      const company = getStorageData("company");
      const { id: companyId } = company;

      await apiUpdateUser({
        companyId,
        updatedUser,
        userId: updatedUser.id
      });
    },
    async getCompanyUsers({ commit }) {
      const company = getStorageData("company");

      const { id: companyId } = company;
      const { data: companyUsers } = await apiGetCompanyUser(companyId);

      commit("setCompanyUsers", companyUsers);
    },
    async getUser({ commit }, userId) {
      const company = getStorageData("company");

      const { id: companyId } = company;
      const { data: user } = await apiGetUserById(companyId, userId);

      commit("setUser", user);
    },
    async getCompanyOperationalInformation({ commit }) {
      const company = getStorageData("company");

      const { id: companyId } = company;

      const apiOperationalResponse = ["acl", "roles", "rpes"].map(type =>
        apiGetOperational(companyId, type)
      );

      const [acl, roles, rpes] = await Promise.all(apiOperationalResponse);

      commit("setOperational", {
        acl: acl.data,
        roles: roles.data,
        rpes: rpes.data
      });
    },
    async deleteUser({ state }) {
      const company = getStorageData("company");

      const { id: companyId } = company;

      await apiDeleteUser(companyId, state.user.id);
    },
    async getUsersAcl({ commit }) {
      const { data: users } = await apiGetUsersAcl();

      commit("setState", {
        key: "usersAcl",
        value: users
      });
    },
    async getUsersProgram({ commit }, userId) {
      const company = getStorageData("company");
      const { id: companyId } = company;

      const { data: program } = await apiGetUserProgram(companyId, userId);

      commit("setState", {
        key: "program",
        value: program
      });
    },
    async getUsersSchedule({ commit }, userId) {
      const company = getStorageData("company");
      const { id: companyId } = company;

      const { data: schedule } = await apiGetUserSchedule(companyId, userId);

      commit("setState", {
        key: "schedule",
        value: schedule
      });
    },
    async getUserRecords({ commit }, params) {
      const company = getStorageData("company");
      const { id: companyId } = company;

      const { data: records } = await apiGetUserRecords(companyId, params.userId, params.date, params.version);

      commit("setState", {
        key: "records",
        value: records
      });

      return records;
    },
    async getUserRecordsDownload({}, params) {
      const company = getStorageData("company");
      const { id: companyId } = company;

      return await apiGetUserRecordsDownload(companyId, params.userId, params.date, params.type, params.version);
    },
    async getUserCertificate({ commit }, params) {
      const company = getStorageData("company");
      const { id: companyId } = company;

      const { data: certificate } = await apiGetUserCertificate(companyId, params.id, params.hash);

      commit("setState", {
        name: "certificate",
        data: certificate
      });

      return certificate;
    },
    async getUserCertificateDownload({}, params) {
      const company = getStorageData("company");
      const { id: companyId } = company;

      return await apiGetUserCertificateDownload(companyId, params.userId, params.hash);
    },
  }
};

export default companyUser;
